/**
 * `/stock` → เมนูแรกของกลุ่ม "คลังอุปกรณ์" ที่ผู้ใช้เข้าได้จริง (FB-2026-0020)
 *
 * เดิม redirect ไป `/stock/issues` เสมอ — role ที่มีแค่ `stock_movements.view` (คีย์ดูสต็อก) ตกหน้า access-denied
 * ลำดับตรงกับเมนูใน `config/navigation.tsx`: สรุปคงเหลือ → ใบเบิก-ยืม → รับเข้าคลัง → ความเคลื่อนไหว
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermission } from '../../hooks/usePermission';

export const STOCK_INDEX_ORDER: { path: string; permission: string }[] = [
  { path: '/stock/summary', permission: 'stock_movements.view' },
  { path: '/stock/issues', permission: 'stock_issues.view' },
  { path: '/stock/receive', permission: 'stock_movements.adjust' },
];

const StockIndexRedirect: React.FC = () => {
  const { hasPermission } = usePermission();
  const target = STOCK_INDEX_ORDER.find((x) => hasPermission(x.permission))?.path ?? '/stock/issues';
  return <Navigate to={target} replace />;
};

export default StockIndexRedirect;
